<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" v-model="valid" @submit.prevent="onValidate">
          <v-card width="400" class="mx-auto mt-5">
            <v-card-title>
              <h1 class="text-h4">تسجيل الدخول</h1>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="model.email"
                label="البريد الالكتروني"
                :type="'email'"
                :rules="emailRules"
                :prepend-icon="'mdi-email'"
                placeholder="email@mail.com"
                required
              />
              <v-text-field
                v-model="model.password"
                label="كلمة المرور"
                :type="showPassword ? 'text' : 'password'"
                :prepend-icon="'mdi-lock'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                required
                :rules="passwordRules"
              />
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn color="primary" type="submit" :disabled="!valid">
                دخول
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "LoginPage",
  metaInfo() {
    return { title: "تسجيل الدخول" };
  },
  data() {
    return {
      valid: true,
      showPassword: false,
      model: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    emailRules() {
      return [
        (v) => !!v || "البريد الالكتروني مطلوب",
        (v) =>
          (v && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) ||
          "البريد الالكتروني غير مقبول",
      ];
    },
    passwordRules() {
      return [(v) => !!v || "كلمة المرور مطلوبة"];
    },
  },

  methods: {
    ...mapActions({
      login: "auth/login",
    }),
    onValidate() {
      if (this.$refs.form.validate()) {
        this.onSubmit();
      }
    },
    async onSubmit() {
      // await this.$store.dispatch("auth/onLogin", this.model);
      // if (this.loggedIn) {
      //   this.$router.push({ name: "home" });
      // }
      await this.login({
        email: this.model.email,
        password: this.model.password,
      });
    },
  },
};
</script>
<style></style>
